export const initState= (state = {isAuth : true}) => {
    return state;
};


// WEBPACK FOOTER //
// ./src/reducers/initReducer.js